import { useEffect } from 'react';

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Spinner } from '@/components/ui/spinner';
import useFileUpload from '@/hooks/useFileUpload';

import useFileSubmit from '../FileUpload/useFileSubmit';
interface Props {
  onUpdate: (avatar: { avatar?: string }) => void;
  name?: string;
  label: string;
  avatar?: string;
  isUserAvatar?: boolean;
  readOnly?: boolean;
  // Optional id for the file input so an external label can trigger the same upload.
  id?: string;
}

const FieldsetAvatar = ({ id, label, onUpdate, avatar, name, isUserAvatar, readOnly }: Props) => {
  const { croppedFile, onAvatarUpload } = useFileUpload();
  const { isLoading, uploadFile } = useFileSubmit({
    stream: true,
    uploadPath: isUserAvatar ? `/www/media/me/upload` : undefined,
    onSuccess: (uploadedFile) => {
      if (uploadedFile?.url) {
        onUpdate({ avatar: uploadedFile.url });
      }
    },
  });

  useEffect(() => {
    if (croppedFile) {
      uploadFile(croppedFile);
    }
  }, [croppedFile, uploadFile]);

  return (
    <div className="relative rounded-full ring-offset-background has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-ring has-[:focus-visible]:ring-offset-2">
      {isLoading && (
        <div className="absolute inset-0 z-10 flex items-center justify-center">
          <Spinner size="md" className="text-current" />
        </div>
      )}
      <Avatar size="2xl">
        <AvatarImage src={avatar} alt={name} />
        <AvatarFallback size="2xl">{name?.charAt(0)?.toUpperCase()}</AvatarFallback>
      </Avatar>
      <input
        id={id}
        type="file"
        accept=".png,.jpeg,.jpg"
        aria-label={label}
        disabled={readOnly}
        onChange={onAvatarUpload}
        className="absolute inset-0 cursor-pointer opacity-0 disabled:cursor-default"
      />
    </div>
  );
};

export default FieldsetAvatar;
